declare var swal: any;
import { Component, Input, OnInit, ViewChild } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';
//import { Chart } from '';
import { DoctorAppointmentsByDoctorcode2Contoller } from '../../../../../../src/app/ncs/models/actor/actor';
import { DoctorAppointmentsByDoctorCode2Request } from '../../../../../../src/app/ncs/models/actor/actor';
//import { ChartOptions, ChartType, ChartDataSets, Label} from 'chart.js';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { SaveCounsellingActivityRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, CounsellingPlanController, CounsellingPlanRequest, CounsellingActivityController, CounsellingActivityRequest, CounsellingActivitiesByTimeController, CounsellingActivitiesByTimeRequest, SaveCounsellingPlanRequest, MisReportCategoriesController, MisReportCategoriesRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbActivityMonitoringModal } from './activitymonitoringmodal/activitymonitoring.modal';
import { timeInterval } from 'rxjs/operators';
import { NgbCustomizeDashboardModal } from './customizedashboard.modal';
import { ApiRequestModel } from '../../../../../../src/app/ncs/models/api_request_model';


@Component({
  selector: 'doc-dash-board',
  templateUrl: './docdashboard.component.html',
  styleUrls: [
    './docdashboard.component.scss']
  ,
  animations: [routerTransition()]
})

export class DocDashboardComponent implements OnInit {
  public ApiReqData: ApiRequestModel;
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public DisplayPresentDate: boolean = true;
  public DisplaySelectedDate: boolean = false;
  public DisplayChangedDate: boolean = false;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public PresentDate: Date;
  public DateSelected: Date;
  public ChangedDate: Date;
  public SelectedDatenew: Date;
  public ProviderCode: number;
  SelectedFacilityCode: number;
  public BranchName: string;
  TodayDate = new Date();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private actorservice: ActorService,
    private parserFormatter: NgbDateParserFormatter,
    private loaderService: SpinnerService,
  ) { }
  ngOnInit() {
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.PresentDate = new Date();
    this.ProviderCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
    this.BranchName = AppData.Instance().SelectedBranchName;
    // this.LoadDoctorAppointmentsByDoctor();
    this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();

    this.CurrentDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 16;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetDoctorAppointmentsByDoctorcodeContoller();
    //alert(this.DateSelected);
  }

  //SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Roleassign(event: any) {
    //  alert(event);
    if (event != null) {


      this.SelectedFacilityName = event;
      this.BranchName = this.SelectedFacilityName;
      //  alert(this.SelectedFacilityName );
      if (this.data == null) {

        this._GetDoctorAppointmentsByDoctorcodeContoller();

      }
      else {

        this.CurrentDoctorAppointmentsByDoctorcodeController =
          this.data.filter(function (v, i, d) {
            //   alert(this.SelectedFacilityCode);
            return v.FacilityName == this.SelectedFacilityName;
          });
      }
      //  this.LoadDoctorAppointmentsByDoctor();
      //  this.LoadDoctorsList(this.SelectedFacilityCode);
    }

  }
  CurrentDoctorAppointmentsByDoctorcodeController: DoctorAppointmentsByDoctorcode2Contoller[];
  CurrentDoctorAppointmentsByDoctorCodeRequest: DoctorAppointmentsByDoctorCode2Request;
  LoadDoctorAppointmentsByDoctor() {
    this.CurrentDoctorAppointmentsByDoctorcodeController = new Array<DoctorAppointmentsByDoctorcode2Contoller>();

    this.CurrentDoctorAppointmentsByDoctorCodeRequest = new DoctorAppointmentsByDoctorCode2Request();
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 16;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.ChangedDate = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.DateSelected = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
    //this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //this.CurrentDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorAppointmentsByDoctorcodeContoller();
  }
  data: DoctorAppointmentsByDoctorcode2Contoller[];
  GetDoctorAppointmentsByDoctorcodeContoller() {

    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.ProviderCode;
    // this.CurrentDoctorsListDoctorAppointmentsByDoctorCodeRequest.FromDate = "";
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiReqData = result;
        if (!this.ApiResData.hasError) {
          this.data = this.ApiResData.Result;
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.data;
          //this.data.filter(function (v, i, d) {
          //  return v.FacilityCode == this.SelectedFacilityCode;
          //});


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  _GetDoctorAppointmentsByDoctorcodeContoller() {

    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ProviderCode = this.ProviderCode;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ConditionalOperator = 16;
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.ChangedDate = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.DateSelected = this.CurrentDoctorAppointmentsByDoctorCodeRequest.FromDate;
    this.SelectedDatenew = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.ToDate = new Date((this.SelectedDatenew).getTime() + (60 * 60 * 24 * 1000));
    this.CurrentDoctorAppointmentsByDoctorCodeRequest.SendApiRequestModel.xLocationCode = this.SelectedFacilityCode;
    this.actorservice.GetDoctorAppointmentsByDoctorcodeContoller2(this.CurrentDoctorAppointmentsByDoctorCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.data = this.ApiResData.Result;
          this.CurrentDoctorAppointmentsByDoctorcodeController = this.data;

          //this.data.filter(function (v, i, d) {
          //  return v.FacilityCode == this.SelectedFacilityCode;
          //});

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  dataChanged(newobj) {
    this.DisplayPresentDate = false;
    this.DisplaySelectedDate = false;
    this.DisplayChangedDate = true;
    this._GetDoctorAppointmentsByDoctorcodeContoller();
  }
  DecrementDate() {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.DisplayPresentDate = false;
    this.DisplaySelectedDate = true;
    this._GetDoctorAppointmentsByDoctorcodeContoller();

  }
  IncrementDate() {
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this.DisplayPresentDate = false;
    this.DisplaySelectedDate = true;
    this._GetDoctorAppointmentsByDoctorcodeContoller();

  }

  
  SelectedPatientAppt: DoctorAppointmentsByDoctorcode2Contoller;

  OpenPatientRegister(p: any) {
    var pt = p as DoctorAppointmentsByDoctorcode2Contoller;

    if (this.SelectedPatientAppt != null &&
      this.SelectedPatientAppt.PatientFormattedCode != pt.PatientFormattedCode) {
      this.SelectedPatientAppt = null;
    }

      this.SelectedPatientAppt = pt;// p as DoctorAppointmentsByDoctorcode2Contoller;
    
  //  alert(this.SelectedPatientAppt.PatientFormattedCode);
    //var pfc = this.SelectedPatientAppt.PatientFormattedCode;
    //this.SelectedPatientFC = pfc;

    //alert(pfc);





  }

}

